import { LogEvent } from 'types';
import { restService } from 'utilities';

export interface GetUserLogsInput {
  address: string;
  limit?: number;
}

export interface GetUserLogsOutput {
  logs: LogEvent[];
}

const getUserLogs = async ({
  address,
  limit = 50,
}: GetUserLogsInput): Promise<GetUserLogsOutput> => {
  try {
    const params: Record<string, any> = {
      limit,
    };

    const response = await restService<any>({
      endpoint: `/logs/user/${address}`,
      method: 'GET',
      params,
    });

    // Return empty array if no response
    if (!response?.data) {
      return { logs: [] };
    }

    // Check if data is directly an array
    if (Array.isArray(response.data)) {
      return { logs: response.data };
    }

    // Check if response has nested data array
    if (response.data.data && Array.isArray(response.data.data)) {
      return { logs: response.data.data };
    }

    // Fallback: return empty array
    return { logs: [] };
  } catch (error) {
    console.error('Error fetching user logs:', error);
    return { logs: [] };
  }
};

export default getUserLogs;
